import styled from 'styled-components';

export const Heading = styled.h1`
  font-family: ${Styles.fontFamily.base};
  line-height: 1.75;
  margin: 1rem auto 0rem;
  text-align: center;
  font-weight: ${Styles.fontWeight.normal};
  text-transform: ${Styles.textTransform.headlines};
  font-size: 1.5rem;

  ${Styles.desktop`
    font-size: 2.25rem;
    margin: 3rem auto 0rem;
  `}
`;
